export default "__VITE_ASSET__Dn216XDq__"